import React from 'react';
import '../components/Report/report.scss'
import FilterDropdown3016 from '../components/Home/filter/FilterDropdown3016';
import InfrastructureReport from '../components/Report/InfrastructureReport';
import {useSearchParams} from "react-router-dom"
import Infrastructure3019 from '../components/Report/IngrastructureReports/InfrastructureReport3019';
import Infrastructure3022 from '../components/Report/IngrastructureReports/InfrastructureReport3022';
import Infrastructure3025 from '../components/Report/IngrastructureReports/InfrastructureReport3025';
import Infrastructure3028 from '../components/Report/IngrastructureReports/InfrastructureReport3028';
import Infrastructure3031 from '../components/Report/IngrastructureReports/InfrastructureReport3031';
import Infrastructure3034 from '../components/Report/IngrastructureReports/InfrastructureReport3034';
import Infrastructure3037 from '../components/Report/IngrastructureReports/InfrastructureReport3037';
import Infrastructure3040 from '../components/Report/IngrastructureReports/InfrastructureReport3040';
import Infrastructure3043 from '../components/Report/IngrastructureReports/InfrastructureReport3043';
import Infrastructure3046 from '../components/Report/IngrastructureReports/InfrastructureReport3046';
import Infrastructure3052 from '../components/Report/IngrastructureReports/InfrastructureReport3052';
import Infrastructure3058 from '../components/Report/IngrastructureReports/InfrastructureReport3058';
import Infrastructure3064 from '../components/Report/IngrastructureReports/InfrastructureReport3064';
import Infrastructure3067 from '../components/Report/IngrastructureReports/InfrastructureReport3067';
import Infrastructure3070 from '../components/Report/IngrastructureReports/InfrastructureReport3070';
import Infrastructure3076 from '../components/Report/IngrastructureReports/InfrastructureReport3076';
import Infrastructure3082 from '../components/Report/IngrastructureReports/InfrastructureReport3082';
import Infrastructure3088 from '../components/Report/IngrastructureReports/InfrastructureReport3088';
import Infrastructure3091 from '../components/Report/IngrastructureReports/InfrastructureReport3091';
import Infrastructure3097 from '../components/Report/IngrastructureReports/InfrastructureReport3097';
import Infrastructure3098 from '../components/Report/IngrastructureReports/InfrastructureReport3098';
import Infrastructure3100 from '../components/Report/IngrastructureReports/InfrastructureReport3100';
import Infrastructure3106 from '../components/Report/IngrastructureReports/InfrastructureReport3106';
import Footer from '../components/Header/Footer';

export default function AllReport() {
  const [queryParameters] = useSearchParams();
  const id = queryParameters.get("id");
  const report_name = queryParameters.get("report_name");
  const type = queryParameters.get("type");

  const componentsMap = {
    3016: InfrastructureReport,
    3019: Infrastructure3019,
    3022: Infrastructure3022,
    3025: Infrastructure3025,
    3028: Infrastructure3028,
    3031: Infrastructure3031,
    3034: Infrastructure3034,
    3037: Infrastructure3037,
    3040: Infrastructure3040,
    3043: Infrastructure3043,
    3046: Infrastructure3046,
    3052: Infrastructure3052,
    3058: Infrastructure3058,
    3064: Infrastructure3064,
    3067: Infrastructure3067,
    3070: Infrastructure3070,
    3076: Infrastructure3076,
    3082: Infrastructure3082,
    3088: Infrastructure3088,
    3091: Infrastructure3091,
    3097: Infrastructure3097,
    3098: Infrastructure3098,
    3100: Infrastructure3100,
    3106: Infrastructure3106,
  };

  const SelectedComponent = componentsMap[id];

  return (
    <>
      <FilterDropdown3016 isAllYearShow={true} id={id} />
      <SelectedComponent id={id} report_name={report_name} type={type} />
      <Footer />
    </>
  );
}

